import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
} from '@angular/core';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-number-stepper',
  imports: [ButtonComponent],
  template: `
    <div class="stepper-container">
      <app-button
        variant="ghost"
        [small]="true"
        [iconStart]="faMinus"
        [disabled]="isAtMin()"
        [ariaLabel]="'Verringern'"
        (click)="decrement()"
      ></app-button>

      <span class="stepper-value">{{ value() }}</span>

      <app-button
        variant="ghost"
        [small]="true"
        [iconStart]="faPlus"
        [disabled]="isAtMax()"
        [ariaLabel]="'Erhöhen'"
        (click)="increment()"
      ></app-button>
    </div>
  `,
  styleUrls: ['./number-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberStepperComponent {
  readonly faMinus = faMinus;
  readonly faPlus = faPlus;

  /** Current value (two-way bindable). */
  readonly value = model(0);

  /** Minimum allowed value. */
  readonly min = input(0);

  /** Maximum allowed value. `null` means no upper limit. */
  readonly max = input<number | null>(null);

  readonly isAtMin = computed(() => this.value() <= this.min());
  readonly isAtMax = computed(() => {
    const max = this.max();
    return max != null && this.value() >= max;
  });

  /** Decrements the value by 1, respecting the minimum. */
  decrement(): void {
    if (!this.isAtMin()) {
      this.value.update((v) => v - 1);
    }
  }

  /** Increments the value by 1, respecting the maximum. */
  increment(): void {
    if (!this.isAtMax()) {
      this.value.update((v) => v + 1);
    }
  }
}
